import type { APICatalogJewelryResponse } from '~/api/catalogApi'
import type { TCatalogNavigation } from '~/layers/catalog/data/types'

export const fromCatalogApi = (item: APICatalogJewelryResponse['catalog']['navigation']): TCatalogNavigation => {
  return {
    page: item.page,
    perPage: item.limit,
    total: item.totalCount,
    lastPage: item.pages,
    isLastPage: item.pages === item.page,
  }
}
